<form class="tag-picker-form d-flex" [formGroup]="form" (submit)="createTag()">
  <div class="w-100">
    <mat-form-field>
      <mat-label>Tag name</mat-label>
      <input
        matInput
        type="text"
        formControlName="name"
        [matAutocomplete]="autocomplete"
      />
      <mat-autocomplete #autocomplete (optionSelected)="createTag()">
        <mat-option
          [value]="option"
          *ngFor="let option of filteredOptions$ | async"
        >
          {{ option }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <button
    luiButton
    class="tag-picker-submit-button ms-1"
    [disabled]="!canCreateTag"
  >
    Create tag
  </button>
</form>

<div class="tag-picker-tags pt-2 d-flex flex-wrap" *ngIf="uniqTags.size">
  <span
    *ngFor="let tag of uniqTags"
    class="tag-picker-tag d-flex overflow-hidden"
    [matTooltip]="tag"
    [matTooltipShowDelay]="500"
  >
    <span
      class="tag-picker-tag-content w-100 overflow-hidden"
      luiThemeColor
      [color]="getTagColor(tag)"
      >{{ tag }}</span
    >
  </span>
</div>
